module.exports = __webpack_public_path__ + "media/images/top-globe-2e1e8de5af49844672110193ade5665f.svg";